import { LoggerModule, ApiModule } from "@packages/common";
import type { Module } from "@webmotors/ioc";

import { CategoriesService } from "./categories.service";

export const CategoriesModule: Module = {
  name: "CategoriesModule",
  modules: [ApiModule, LoggerModule],
  providers: [CategoriesService],
};
